export default {
  title01: "Текущо време",
  title02: "24 часа",
  title03: "Виж 10-дневна прогноза за времето",
  title04: "AQI",
  title05: "Виж цялата информация",
  title06: "ИЗГРЕВ И ЗАЛЕЗ",
  title07: "ФАЗА НА ЛУНАТА",
  title08: "Следващото пълнолуние",
  title09: "Следващото новолуние",
  title10: "ДЕН",
  title11: "НОЩ",
  title12: "Изгрев",
  title13: "Залез",
  title14: "Лунен изгрев",
  title15: "Лунен залез",
  title16: "Източник",
  title17: "Начало",
  title18: "Край",
  title19: "Използвай текущото местоположение",
  title20: "Търсене на град",
  title21: "Усеща се като",
  title22: "Усеща се като в сянка",
  title23: "Сега",
  title24: "Днес",
  title25: "НЕД",
  title26: "ПОН",
  title27: "ВТ",
  title28: "СР",
  title29: "ЧЕТ",
  title30: "ПЕТ",
  title31: "СЪБ",
  title32: "Зареждане...",
  title33: "Сега",
  title34: "Почасово",
  title35: "Дневно",
  title36: "Слънце и Луна",
  title37: "Качество на въздуха",
  title38: "Контакт с: xlf550402@gmail.com",
  title39: "Политика за поверителност",
  title40: "Авторско право © comfortweather.com 2020 - 2026. Всички права запазени.",
  title41: "Данни предоставени от",
  title42: "Високо",
  title43: "Ниско",
  title44: "Приемам",
  title45:
    "Благодарим ви, че използвате ComfortWeather! За да защитим по-добре вашите законни права и интереси, моля, прочетете внимателно ",
  title46: "Политиката за поверителност",
  title47: " преди използване.",
  title48: "",
  title49: "Контакт с: xyjph123@gmail.com",
  title50: "Авторско право © 24hweather.com 2020 - 2026. Всички права запазени.",
  title51:
    "Благодарим ви, че използвате 24hweather! За да защитим по-добре вашите законни права и интереси, моля, прочетете внимателно ",
  title52: "Забелязана е промяна на местоположението ви. Искате ли да го актуализирате?",
  title53: "Потвърди",
  title54: "Отказ",
  title55: "Назад",
  title56: "Новини",
  title57: "Актуализиране на времето...",
  title58: "Времето е актуализирано",
  title59: "Виж всички",
  title60: "Авторско право © mobi321.com 2020 - 2026. Всички права запазени.",
  title61: "Вчера",
  title62: "Утре",
  title63: "Виж 15-дневна прогноза за времето",
  title64: "Днешни подробности",
  title65: "Rahu Kaal",
  title66: "Индекси за начин на живот",
  title67: "Индекси за начин на живот",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Трудно за сушене",
  title103: "Бавно сушене",
  title104: "Суши се добре",
  title105: "Бързо сушене",
  title106: "Много бързо сушене",

  title107: "Неподходящо",
  title108: "Скромно изживяване",
  title109: "Подходящо за водни забавления",
  title110: "Много подходящо",
  title111: "Перфектни условия",

  title112: "Подкрепящо здравето",
  title113: "Неутрални условия",
  title114: "Малко по-висок риск",
  title115: "Висок риск",
  title116: "В екстремен риск",

  title117: "Неподходящо",
  title118: "Малко подходящо",
  title119: "Подходящо за дейности на открито",
  title120: "Много подходящо",
  title121: "Отлични условия",

  title122: "Много сухи условия",
  title123: "Вероятно сухо",
  title124: "Леко сухо",
  title125: "Малко вероятно да е сухо",
  title126: "Много малко вероятно да е сухо",

  title127: "Не се препоръчва",
  title128: "Приемливо",
  title129: "Добър ден",
  title130: "Много добри условия",
  title131: "Идеални условия",
};
